import script from "./PersonalCardNot.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCardNot.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCardNot.vue?vue&type=style&index=0&id=47c34fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c34fa4"]])

export default __exports__